import { render, staticRenderFns } from "./tuijian-rebang.vue?vue&type=template&id=4605ff74&"
import script from "./tuijian-rebang.vue?vue&type=script&lang=js&"
export * from "./tuijian-rebang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports